import React, { useState, useContext, useCallback, useEffect } from "react"
import styles from "../../../styles/Page-with-Sidebar.module.css"
import { InputText } from "primereact/inputtext"
import { UserContext } from "../../../context/userContext"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { LoaderMedium } from "../../../components/Loaders"
import { getTimeAgo, sortListByDate, truncateString } from "../Utils"
import { Checkbox } from "primereact/checkbox"
import { Button } from "primereact/button"
import {
  trApiGetChatConversations,
  trApiChatConvSetRead,
} from "../telerecoveryApi"

export default function LeftChatConvList({
  participants,
  openNewParticipantChat,
  openConv,
  setHasConvs,
  convList,
  setConvList,
}) {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [filteredConvList, setFilteredConvList] = useState([])
  const [selectedConv, setSelectedConv] = useState(null)
  const [searchTerm, setSearchTerm] = useState("")
  const [isLoading, setIsLoading] = useState(true)
  const [showSearch, setShowSearch] = useState(false)
  const [unreadFilter, setUnreadFilter] = useState(false)

  useEffect(() => {
    if (convList) {
      let updatedFilteredConvList = convList.filter(
        (s) =>
          searchTerm === "" ||
          s.caseName.toLowerCase().includes(searchTerm.toLowerCase()),
      )
      setFilteredConvList(updatedFilteredConvList)
    }
  }, [convList])

  const selectConversation = (conv) => {
    setSelectedConv(conv.sid)
    markConversationRead(conv.sid)
    openConv({
      sid: conv.sid,
      participant: {
        id: conv.caseId,
        name: conv.caseName,
        initials: conv.caseInitials,
      },
    })
  }

  const markConversationRead = (convSid) => {
    trApiChatConvSetRead(userCtx.tokens.getTelerecoveryToken(), {
      convSid,
      fromPeer: true,
    }).then((resp) => {
      const updatedList = convList.map((conv) => {
        if (conv.sid === convSid) {
          return { ...conv, containsUnread: false }
        }
        return conv
      })
      setConvList(updatedList)
    })
  }

  const loadConvList = useCallback(() => {
    trApiGetChatConversations(
      userCtx.tokens.getTelerecoveryToken(),
      user.staff_id,
      user.organization_id,
    )
      .then(
        (response) => {
          let _convList = Array.from(response)
          let formattedConvList = []

          _convList.forEach((conv) => {
            let participant = participants.find(
              (s) => conv.participantId === s.participant_id,
            )
            if (participant) {
              formattedConvList.push({
                sid: conv.sid,
                caseId: conv.participantId,
                caseName: participant.name,
                caseInitials: participant.initials,
                lastMessageAt: conv.lastMessageAt
                  ? conv.lastMessageAt + "Z"
                  : conv.lastMessageAt,
                containsUnread: conv.staffContainsUnread,
              })
            }
          })
          sortListByDate(formattedConvList, "lastMessageAt")
          setConvList(formattedConvList)
          setHasConvs(formattedConvList.length > 0)
          if (formattedConvList.length > 0) {
            selectConversation(formattedConvList[0])
          }
        },
        (err) => console.log(err),
      )
      .catch((err) => console.log(err))
      .finally(() => {
        setIsLoading(false)
      })
  }, [user.staff_id, user.organization_id, participants])

  useEffect(() => {
    loadConvList()
  }, [loadConvList])

  const search = (sTerm) => {
    setSearchTerm(sTerm)
    setFilteredConvList(
      convList.filter(
        (s) =>
          sTerm === "" ||
          s.caseName.toLowerCase().includes(sTerm.toLowerCase()),
      ),
    )
  }

  if (isLoading) {
    return <LoaderMedium />
  }

  if (convList.length > 0) {
    return (
      <div
        className={styles.conversations_menu}
        style={{ backgroundColor: "#e7e0f180", paddingRight: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "44px",
            marginBottom: "30px",
          }}
        >
          {!showSearch && (
            <Button
              className={gMessages.searchBtn}
              icon="pi pi-search"
              onClick={() => setShowSearch(true)}
            />
          )}
          {!showSearch && (
            <Button
              className={`custom_button_icon ${gMessages.newChatBtn}`}
              label="New Message"
              icon="pi pi-plus"
              onClick={() => {
                openNewParticipantChat()
                setSelectedConv(null)
              }}
            />
          )}
          {showSearch && (
            <span className="p-input-icon-left" style={{ width: "100%" }}>
              <i className="pi pi-search" />
              <InputText
                className={gMessages.searchInput}
                value={searchTerm}
                onChange={(e) => search(e.target.value)}
                placeholder="Search"
              />
              <Button
                className={`custom_button_icon ${gMessages.closeBtn}`}
                icon="pi pi-times"
                onClick={() => {
                  setShowSearch(false)
                  setSearchTerm("")
                  setFilteredConvList(convList)
                }}
              />
            </span>
          )}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3 style={{ color: "#383838", fontSize: "16px", fontWeight: "700" }}>
            Recents
          </h3>
          <div className={gMessages.checkbox_unread}>
            <Checkbox
              inputId="unreadFilter"
              onChange={(e) => {
                setUnreadFilter(e.checked)
                setFilteredConvList(
                  convList.filter((s) => (e.checked ? s.containsUnread : true)),
                )
              }}
              checked={unreadFilter}
            />
            <label
              style={{ color: "#383838", fontSize: "14px" }}
              htmlFor="unreadFilter"
            >
              Unread
            </label>
          </div>
        </div>
        {filteredConvList.length === 0 && (
          <h3
            style={{
              marginTop: "20px",
              textAlign: "center",
              color: "#383838",
              fontSize: "20px",
            }}
          >
            No chats
          </h3>
        )}
        <ul
          className={`${gMessages.chatConvListContainer} ${gMessages.myScrollbar}`}
        >
          {filteredConvList &&
            filteredConvList.map((conv) => (
              <li
                key={conv.sid}
                onClick={() => {
                  selectConversation(conv)
                }}
                style={{ width: "100%", position: "relative" }}
              >
                <div
                  className={`${gMessages.convElement} ${selectedConv === conv.sid && gMessages.selected}`}
                >
                  <span className={gMessages.userInitials}>
                    {conv.caseInitials}
                  </span>
                  <div>
                    <p>{truncateString(conv.caseName, 22)}</p>
                    <p className={gMessages.timeAgo}>
                      {getTimeAgo(conv.lastMessageAt)}
                    </p>
                  </div>
                </div>
                {conv.containsUnread && (
                  <span className={gMessages.unread}></span>
                )}
              </li>
            ))}
        </ul>
      </div>
    )
  }

  return (
    <div
      className={styles.conversations_menu}
      style={{ backgroundColor: "#e7e0f180" }}
    ></div>
  )
}
